





















































import { computed, defineComponent, PropType } from '@vue/composition-api';
import { Carousel, Slide } from 'vue-carousel';
import ImageContainer from 'src/components/common/better-load-image/index.vue';

const name = 'ttam-creative-music-carousel-preview-compose';
export default defineComponent({
  name,
  components: { Carousel, Slide, ImageContainer },
  props: {
    imageUrlList: {
      type: Array as PropType<Array<string>>,
      require: true,
      default: () => [],
    },
    activeIndex: {
      type: Number,
      default: 0,
    },
    onPlaying: {
      type: Boolean,
      default: false,
    },
    playIconVisible: {
      type: Boolean,
      default: true,
    },
    paginationVisible: {
      type: Boolean,
      default: true,
    },
    imageContainerWidth: {
      type: String,
      default: '258px',
    },
    imageContainerHeight: {
      type: String,
      default: '457px',
    },
    backgroundColor: {
      type: String,
      default: '#000',
    },
  },
  setup(props, ctx) {
    const checkIsActiveItem = index => index === props.activeIndex;
    const emitChangeIndex = index => {
      const doEmit = () => ctx.emit('update:activeIndex', index);

      if (index === props.activeIndex) {
        return;
      }

      doEmit();
    };

    const tootlePlay = () => {
      ctx.emit('change-playing');
    };
    const currentIndex = computed({
      get() {
        return props.activeIndex;
      },
      set: emitChangeIndex,
    });

    return {
      tootlePlay,
      currentIndex,
      checkIsActiveItem,
      emitChangeIndex,
    };
  },
});
